<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="100006" />
    <section slot="titleRight">
      <qx-permpisions permpisions="1100201">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions="">
        <el-button type="primary" plain @click="toRoleUser">人员分布</el-button>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section slot-scope="scope">

                <section v-if="scope.column.property === 'count'" >
                  <template v-if="checkPermpisions('1007010301')">
                    <span class="primary cur" @click="toUserList(scope.row)">
                        {{
                        scope.row[scope.column.property]
                        }}
                      </span>
                  </template>
                  <template v-else>
                    <span class="primary cur" >
                          {{
                        scope.row[scope.column.property]
                      }}
                        </span>
                  </template>
                </section>
              <section v-else>{{ scope.row[scope.column.property] }}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="140" fixed="right">
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '1100203',
                    showCondition: true,
                    name: '修改',
                    event: () => toEdit(scope.row.roleId),
                  },
                  {
                    permpisions: '1100205',
                    showCondition: true,
                    name: '删除',
                    event: () => del(scope.row.roleId),
                  },
                  {
                    showCondition: true,
                    name: '查看',
                    event: () => toEdit(scope.row.roleId, 'detail'),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.roleId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableBtn from 'components/tableBtn/tableBtn';
import {
  roleList,
  roleDel,
} from 'api/system';
import LogRightDialog from 'components/logRightDialog';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    TableBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'roleName',
            label: '角色名称',
          },
          {
            prop: 'opName',
            label: '创建人',
          },
          {
            prop: 'createDate',
            label: '创建时间',
          },
          {
            prop: 'count',
            label: '人员',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: roleList,
    async del (roleId) {
      const confirmRes = await this.$confirm('是否确认删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
      if (confirmRes === 'confirm') {
        const res = await roleDel({
          roleId,
        });
        if (!res.failed) {
          this.$message.success('删除成功');
          this.getData();
        }
      }
    },
    toUserList (item) {
      this.jump({
        label: '员工管理',
        url: `/manage/system/jurisdiction/worker?roleId=${item.roleId}`,
      });
    },
    toRoleUser (item) {
      this.jump({
        label: '人员分布',
        url: '/manage/system/jurisdiction/jurisdiction/roleUser',
      });
    },
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
    toEdit (id, type) {
      let label = '新增权限';
      if (type) {
        label = '查看权限';
      } else if (id) {
        label = '修改权限';
      }
      this.jump({
        label,
        url: `/manage/system/jurisdiction/jurisdiction/edit${id ? '?id=' + id : ''}${type ? '&type=' + type : ''}`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
